<template>
    <custom-context-menu :menu-items="menuItems" :route-to="routeTo">
        <targeting-router-link-internal data-cy="transaction-link" :to="routeTo">
            <slot/>
        </targeting-router-link-internal>
        <UModal v-model:open="showDeleteConfirmation">
            <template #content>
                <UCard>
                    <template #header>
                        Slett bilag?
                    </template>

                    <div class="flex space-x-2 justify-end">
                        <UButton
                            data-cy="cm-transaction-delete-cancel"
                            @click="showDeleteConfirmation = false"
                        >
                            Nei
                        </UButton>
                        <UButton
                            data-cy="cm-transaction-delete-confirm"
                            icon="i-ph-trash"
                            color="error"
                            @click="handleDelete"
                        >
                            Ja
                        </UButton>
                    </div>
                </UCard>
            </template>
        </UModal>
    </custom-context-menu>
</template>

<script setup lang="ts">
import {TRANSACTIONS} from '@/transaction'
import {computed, onMounted, ref} from 'vue'
import {deleteTransaction, getTransactionByUuid} from '@/transaction/transaction.service'
import {Transaction} from '@/types/transaction/Transaction'
import emitter from '@/services/infrastructure/emitter'
import {DELETE_TRANSACTION} from '@/types/transaction/TransactionEvent'
import {useEditTransactionCreator} from '@/transaction/edit-transaction/EditTransaction.service'
import { CustomContextMenu } from '@tritt/multipanel'
import {PanelContentRequest} from '@tritt/multipanel'
import {IContextMenuItem} from '@tritt/multipanel'
import { TargetingRouterLinkInternal } from '@tritt/multipanel'


const props = defineProps({
    transactionUuid: {
        type: String,
        required: true
    }
})

const queryValues = computed(() => {
    return {
        transactionUuid: props.transactionUuid
    }
})

const {openEditTransaction} = useEditTransactionCreator()

const transactionUuid = computed(() => props.transactionUuid)
const transaction = ref<Transaction>()

const showDeleteConfirmation = ref(false)

const routeTo = computed<PanelContentRequest>(() => ({...TRANSACTIONS, queryValues: queryValues.value}))

const handleDelete = async () => {
    if (transaction.value) {
        await deleteTransaction(transactionUuid.value)
        emitter.emit(DELETE_TRANSACTION, transaction.value)
        showDeleteConfirmation.value = false
    }
}

const menuItems = computed(() => {
    const mItems: IContextMenuItem[] = []

    if (transaction.value && !transaction.value.deleted) {
        mItems.push({
            label: 'Endre bilag',
            ['data-cy']: 'cm-edit-transaction',
            onSelect: () => openEditTransaction(transaction.value as Transaction),
        })

        mItems.push({
            slot: 'confirmation' as const,
            label: 'Slett bilag',
            color: 'error' as const,
            ['data-cy']: 'cm-delete-transaction',
            onSelect: () => showDeleteConfirmation.value = true,
        })
    }

    return mItems
})

onMounted(async () => {
    if (transactionUuid.value) {
        transaction.value = await getTransactionByUuid(transactionUuid.value)
    }
})

</script>

<style scoped>

</style>